package com.artvending.warden

import kotlinx.browser.window
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

object fixingLogger {
	private fun getTodayKey(): String {
		val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
		return "app_logs_$today"
	}
	
	fun fix(geolocation: Point, qrCode: String) {
		val key = getTodayKey()
		val existingLogs = window.localStorage.getItem(key) ?: ""
		val updatedLogs = "$existingLogs\n${LocalDateTime.now()} - ${geolocation.x}, ${geolocation.y} - $qrCode"
		window.localStorage.setItem(key, updatedLogs)
	}
}